import { useEffect, useState } from "react";
import { messages } from "../i18n/index.ts";

const HINT_MS = 4000;

/**
 * Seçili hücre açıklamasını tahtadan bağımsız bildirim yuvasına taşır.
 * Seçim kendisi kalıcıdır; yalnız açıklama sonraki etkileşimde kaybolur.
 */
export function useBoardSelectionHint(pinned: number | null): string | null {
  const [hintFor, setHintFor] = useState<number | null>(null);

  useEffect(() => {
    if (pinned === null) {
      setHintFor(null);
      return;
    }

    setHintFor(pinned);
    const dismiss = () => setHintFor(null);
    const timer = window.setTimeout(dismiss, HINT_MS);
    window.addEventListener("pointerdown", dismiss, { once: true });
    window.addEventListener("keydown", dismiss, { once: true });
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener("pointerdown", dismiss);
      window.removeEventListener("keydown", dismiss);
    };
  }, [pinned]);

  return hintFor === null ? null : messages.board.hint(hintFor + 1);
}
